module.exports = __webpack_public_path__ + "img/jinshan@2x.3e40a807.png";